module.exports = __webpack_public_path__ + "img/logo-menu.2d0ba8eb.png";